import { useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks/hooks";
import { InputRow } from "./InputRow";
import { setWellInputsData } from "../../store/slices/iprCalculatorSlice";
import { UnitConverter } from "../../components/MeasurementUnits/UnitConverter";
import type { IDDItem } from "../../components/common/DropdownMenu";

// const fields = ["k-g", "a", "b"];

interface IProps {
	wellId: "well1" | "well2",
	onSelectUnit: (inputId: string, unitId: string) => void,
	onInputChange: (inputName: string, value: number | null) => void,
}

const converter = new UnitConverter();

export const JonesInputs = (props: IProps) => {
	const dispatch = useAppDispatch();
	const calculator = useAppSelector(state => state.iprCalculator);

	const onSelectUnit = useCallback((inputId: string, selectedUnitId: string) => {
		const well = props.wellId === "well1" ? calculator.well1 : calculator.well2;

		dispatch(
			setWellInputsData({
				wellId: props.wellId,
				fields: well.jonesInputs.map(input =>
					input.id === inputId
						? {
							...input,
							currentValue: converter.convert(input.currentValue ?? 0, input.currentUnitId, selectedUnitId),
							baseValue:
								input.userValue && input.userUnitId
									? converter.convert(input.userValue, input.userUnitId, input.baseUnitId)
									: converter.convert(input.currentValue ?? 0, input.currentUnitId, input.baseUnitId),
							currentUnitId: selectedUnitId,
						}
						: input
				),
			})
		);
	}, [dispatch, calculator]);

	const unitsDDItems: { [key: string]: IDDItem[] } = useMemo(() => {
		const well = props.wellId === "well1" ? calculator.well1 : calculator.well2;

		return well.jonesInputs.reduce<Record<string, IDDItem[]>>((acc, input) => {
			const units = converter.getUnitsByCategory(input.unitCategoryId);
			acc[input.id] = units.map(unit => ({
				id: unit.id,
				translationKey: `measurement_units.${unit.category}.${unit.id}`
			} as IDDItem));
			return acc;
		}, {});

	}, [calculator, props.wellId]);

	const inputs = useMemo(() => {
		return props.wellId === "well1" ? calculator.well1.jonesInputs : calculator.well2.jonesInputs;
	}, [calculator, props.wellId]);

	return <div className="ipr__jones-well-inputs">
		{inputs.map((input) => (
			<InputRow
				key={`${props.wellId}-jones-${input.id}`}
				inputId={input.id}
				dropdownItems={unitsDDItems[input.id]}
				onInputChange={props.onInputChange}
				onSelectUnit={onSelectUnit}
			/>
		))}
	</div>;
};